import { FC, useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { Image } from 'components/pages/Starting/components/Image';

import { useGetProgressData } from 'hooks/useGetProgressData';

import { Curtain } from 'components/parts/Curtain';
import { Progressive } from 'components/parts/Progressive';
import { RootState } from 'store/index';

// import styles from './Redirect.module.scss'
export const Redirect: FC = () => {
  const requestedDirectory = useSelector((state: RootState) => state.progress.requestedDirectory);
  console.log(`Redirect：${requestedDirectory}`);
  const { isLoading } = useGetProgressData();
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);
  const [progress, setProgress] = useState(0);
  const [nextStep, setNextStep] = useState(false);
  const navigate = useNavigate();

  // useEffectフックを使用して副作用を管理
  useEffect(() => {
    // 画像の読み込みが完了し、APIからのデータ取得が完了している場合、プログレスを100%に設定し、500ms後に次のステップを設定
    if (!isLoading && imageLoaded) {
      setProgress(100);
      setTimeout(() => setNextStep(true), 500);
      return;
    }
    // プログレスを定期的に1ずつ増やす。プログレスが70に達したときは、一度だけ100msの遅延を入れる
    const interval = setInterval(() => {
      if (progress >= 100) {
        clearInterval(interval);
      } else {
        if (progress === 70) {
          setTimeout(() => setProgress(progress + 1), 100);
        } else {
          setProgress(progress + 1);
        }
      }
    }, 10);
    // コンポーネントがアンマウントされたとき、または依存性配列中の値が変更されたときに、インターバルをクリア
    return () => clearInterval(interval);
  }, [progress, isLoading, imageLoaded]);

  useEffect(() => {
    if (!isLoading && nextStep && requestedDirectory !== '/') {
      console.log(`${requestedDirectory} へ移動`);
      navigate(requestedDirectory);
    }
  }, [navigate, requestedDirectory, isLoading, nextStep]);

  // データの読み込みがまだ完了していない、または次のステップに進むべきでない場合、プログレッシブバーと画像を表示
  if (isLoading || !nextStep) {
    return (
      <>
        <Progressive progress={progress} />
        <Image
          doComplete={() => {
            setImageLoaded(() => true);
          }}
        />
      </>
    );
  }

  // データの読み込みが完了し、次のステップに進むべき場合、カーテンコンポーネントとホーム画面に戻るボタンを表示
  return (
    <>
      <Curtain handleClick={() => navigate(requestedDirectory)} />
    </>
  );
};
